/* eslint-disable no-unused-vars,no-console,no-else-return,object-shorthand */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import {getPins} from '../../../../../redux/actionCreators/async/employees';
import * as syncActionCreators from '../../../../../redux/actionCreators/sync';
import * as contactStore from  '../../../../../redux/actionCreators/sync/contacts';
import * as contactApi from    '../../../../../redux/actionCreators/async/contacts';
import * as companyApi from    '../../../../../redux/actionCreators/async/companies';
import { lowerCase, map, replace } from 'lodash';
import { showSnackBar } from '../../../../../redux/actionCreators/sync/ui';

import Button from '../../../../../common/components/Button';
import TransferItemOwnershipIcon from '../../../../../common/svgs/TransferItemOwnershipIcon';
import IconButton from 'material-ui/IconButton';
import Modal from '../../../../../common/components/Modal';
import ModalX from '../../../../../common/svgs/ModalX';
import RouteTransitionBlocker from '../../../../r_ApplicantDashboard/f_RouteTransitionBlocker';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

const MODES = {
  loading: 0,
  ready: 1
};

@connect(state => ({
  pinnedContacts: state.pins.contacts,
}))

export default class ContactTransferOwnership extends Component {
  static propTypes = {
    company : PropTypes.object.isRequired,
    contact : PropTypes.object.isRequired,
    contacts : PropTypes.array.isRequired,
    dispatch : PropTypes.func.isRequired,
    onClose : PropTypes.func.isRequired,
    pinnedContacts: PropTypes.array,

    // table
    staticData: PropTypes.object.isRequired,
    tableHeight: PropTypes.number
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      showTransitionBlocker: false,
      selectedContacts: [],
      eligibleContacts: [],
      viewMode: MODES.loading,
      tableColumns: [
          'Id',
          'Company',
          'Name',
          'Status',
          'Actions'
      ]
    };
  }

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getPins((err, pins) => {
        if (!err) {
          dispatch(syncActionCreators.loadPins(pins));}
      }
    ));

    const eligibleContacts = this.props.pinnedContacts
      .filter(item => item.profile.companyId !== this.props.company.id);

    this.setState({eligibleContacts: eligibleContacts});
  }

  componentDidMount() {
    this.filterContactCompanies();
  }

  // A company cannot be left without any contacts.
  // filterContactCompanies removes contacts from eligibleContacts if they are the only contact remaining in a company or, in other
  // words if removing the contact from the company would leave the company without contacts.
  filterContactCompanies()
  {
    const eligibleCompanies = this.state.eligibleContacts.map(c => ({id:c.company.id, valid:false}));

    Promise.all(eligibleCompanies.map(c => {
      this.props.dispatch(companyApi.getCompanyContacts(c.id, (err, companyContacts) => {
          if (err || !companyContacts) {
            return console.error(err || 'Fetch failed.');
          }

          if (companyContacts.body.data.items.length < 2) {
            const eligibleContacts = this.state.eligibleContacts;
            const index = eligibleContacts.findIndex(contact => contact.company.id === c.id);
            if (index !== -1) {
              eligibleContacts.splice(index, 1);
              this.setState({eligibleContacts: eligibleContacts});
            }
          }
        }));
    }))
    .then(
      () => (this.setState({viewMode: MODES.ready}))
    );
  }
  handleClose = (event) => {

    // Close Dialog
    this.props.onClose && this.props.onClose(event);
  };
  handleConfirmTransfer = (row) => {
    this.setState({showTransitionBlocker: true, rowToMove: row});
  };
  handleTransferContact = () => {

    // update contact with company id (this.props.company.id)
    const contactToUpdate = this.state.rowToMove;

    contactToUpdate.company = ({id: this.props.company.id, companyStatus: this.props.company.companyStatus});
    contactToUpdate.profile.companyId = this.props.company.id;

    this.props.dispatch(contactApi.updateContactOwner(contactToUpdate, (err, updatedContact) => {
      if (err || !updatedContact) {
        return console.error(err || 'Update failed.');
      }

      this.props.dispatch(contactStore.updateProfile(updatedContact));
      this.props.dispatch(showSnackBar(`Transferred ownership of ContactId: ${contactToUpdate.profile.id} to CompanyId: ${contactToUpdate.profile.companyId}`));

      this.setState(
        {
         viewMode: MODES.loading
      });

      // update state to remove job from list
      const eligibleContacts = this.state.eligibleContacts;
      const index = eligibleContacts.findIndex(contact => contact.profile.id === this.state.rowToMove.profile.id);
      if (index !== -1) {
        eligibleContacts.splice(index, 1);
      }

      this.setState({
        eligibleContacts: eligibleContacts,
        rowToMove: null,
        viewMode: MODES.loading,
        showTransitionBlocker: false,
      });

      // regenerate the list of eligibleContacts in case some have become ineligible to be moved as they
      // have become the only contact left in a company
      this.filterContactCompanies();
    }));

    // update parent with new contact
    // not sure this is necessary, doesn't seem to have an effect
    this.props.contacts.push(contactToUpdate);
  };

  // table column rendering functions
  renderActions(header, row, index) {
    if (header) {
      return this.renderHeader('Actions', 'actions');
    }

    // overflow visible hack for tooltips in TableRowColumn
    return (
      <TableRowColumn key={`Actions ${index}`} data-id={`Actions ${index}`} className='actions' style={{overflow: 'visible'}}>
        <IconButton tooltip='Transfer Contact' tooltipPosition={'bottom-center'} onClick={this.handleConfirmTransfer.bind(this, row)}>
          <TransferItemOwnershipIcon data-id={`Move${index}`} className='action-button' />
        </IconButton>
      </TableRowColumn>
    );
  }
  renderCompany(isHeader, row, index) {
    if (isHeader) {
      return this.renderHeader('Company', 'company', 'company', true);
    }

    return (
      <TableRowColumn data-id={`Company${index}`} className='company'>
        {row.company.name}
      </TableRowColumn>
    );
  }
  renderHeader(headerText, className, columnName) {
    if (!className) {
      className = replace(lowerCase(headerText), ' ', '-');
    }
    return (
      <TableHeaderColumn className={cx(className)}>
        <div>
          {headerText}
        </div>
      </TableHeaderColumn>
    );
  }
  renderId(isHeader, row, index) {
    if (isHeader) {
      return this.renderHeader('Contact #', 'contact-number', 'id', true);
    }

    return(
      <TableRowColumn data-id={`Contact Number${index}`} className='contact-number'>
        <div>{row.profile.id}</div>
      </TableRowColumn>
    );
  }
  renderName(isHeader, row, index) {
    if (isHeader) {
      return this.renderHeader('Name', 'name', 'name', true);
    }

    return (
      <TableRowColumn data-id={`Name${index}`} className='title'>
        {row.user.firstName} {row.user.lastName}
      </TableRowColumn>
    );
  }
  renderStatus(header, row, index) {
    if (header) {
      return this.renderHeader('Status', 'status', 'contactStatus', true);
    }

    return (
      <TableRowColumn key={`Status #${index}`} data-id={`Status #${index}`} className='status'>
        <div className='status-circle' data-id='Status Icon' style={
          {
            backgroundColor: this.props.staticData.companyStatus.find(s => s.id === row.company.companyStatus).color,
            borderColor: this.props.staticData.companyStatus.find(s => s.id === row.company.companyStatus).color
          }} />
        {this.props.staticData.companyStatus.find(s => s.id === row.company.companyStatus).name}
      </TableRowColumn>
    );
  }

  // table rendering function
  renderContactTable() {
    return (
      <div className='contact-table'>
        <Table selectable={false}
               multiSelectable={false}
               fixedHeader
               height={this.props.tableHeight || 'calc(100vh-0px)'}
               onSelectionChange={this.handleTableSelectionChange}
               onClick={this.handleTableSelectionChange}
        >
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              {map(this.state.tableColumns, (column) => {
                return this[`render${column}`](true);
              })}
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {
              this.state.viewMode === MODES.loading
              &&
              <div className='table-no-data'>Loading Contacts</div>
            }
            {
              this.state.viewMode === MODES.ready
              && this.state.eligibleContacts.length === 0
              &&
              <div className='table-no-data'>No Eligible Contacts Available</div>
            }
            {
              this.state.viewMode === MODES.ready
              && this.state.eligibleContacts.length > 0
              &&
              map(this.state.eligibleContacts, (row, index) => {
                return (
                  <TableRow key={`${row.profile.id}`} data-id={`Contact ${row.profile.id}`}>
                    {
                      map(this.state.tableColumns, (column) => {
                          return this[`render${column}`](false, row, index);
                        }
                      )
                    }
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Table>
      </div>
    );
  }

  // component render
  render() {
    return (
      <Modal onClickOut={this.handleClose}>
        {
          this.state.showTransitionBlocker
          &&
          <RouteTransitionBlocker
            secondaryAction={this.handleTransferContact}
            secondaryButtonLabel='Transfer Contact'
            cancelAction={() => this.setState({showTransitionBlocker: false, rowToTransfer: null})}
            primaryAction={() => this.setState({showTransitionBlocker: false, rowToTransfer: null})}
            primaryButtonLabel='Cancel'
            transitionText={`Are you sure you want to move Contact #<b>${this.state.rowToMove.profile.id}</b><br>from: <b>${this.state.rowToMove.company.name}</b><br>to: <b>${this.props.company.name}</b>?`}
          />
        }
        <div className='transferContactOwnership-dialog'>
          <ModalX onClick={this.handleClose} />
          <h1 className={'modal-content-title'}>Transfer Pinned Contacts</h1>
          <div className='grid transferContactOwnership-dialog-fields'>
            <div className='row'>
              <div className='col'>{this.renderContactTable()}</div>
            </div>
          </div>
          <div className='transferContactOwnership-dialog-actions'>
            <Button data-id='transfer contacts' label='Close' onClick={this.handleClose} disabled={this.state.transferring} />
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/ContactTransferOwnership/index.js